import React from "react";
import { ContentLayout, HeaderBreadcrumbs } from "../../../shared";
import { BrandingConfig } from "./BrandingConfig";
import { BusinessDetailsConfig } from "./BusinessDetailsConfig";
import { ContactConfig } from "./ContactConfig";
import { LinksConfig } from "./LinksConfig";
import { OthersConfig } from "./OthersConfig";
import { RegionConfig } from "./RegionConfig";
import { SocialConfig } from "./SocialConfig";
import { ThemeConfig } from "./ThemeConfig";
import { AppPlatformSettingsConfig } from "./AppPlatformSettingsConfig";

export const TenantConfigPage = () => {
  const breadcrumbs = [
    { name: "Dashboard", href: "/" },
    { name: "Tenant Config" },
  ];

  const tabs = React.useMemo(
    () => [
      {
        label: "Branding",
        value: "1",
        panel: <BrandingConfig />,
      },
      {
        label: "Business Details",
        value: "2",
        panel: <BusinessDetailsConfig />,
      },
      {
        label: "App Settings",
        value: "8",
        panel: <AppPlatformSettingsConfig />,
      },
      {
        label: "Theme",
        value: "3",
        panel: <ThemeConfig />,
      },
      {
        label: "Region",
        value: "4",
        panel: <RegionConfig />,
      },
      {
        label: "Links",
        value: "5",
        panel: <LinksConfig />,
      },
      {
        label: "Social",
        value: "6",
        panel: <SocialConfig />,
      },
      {
        label: "Contact",
        value: "7",
        panel: <ContactConfig />,
      },

      {
        label: "Others",
        value: "9",
        panel: <OthersConfig />,
      },
    ],
    [],
  );

  return (
    <ContentLayout
      title="Tenant Config"
      breadcrumbs={<HeaderBreadcrumbs links={breadcrumbs} />}
      tabProps={{
        label: "tenantConfig",
        list: tabs,
      }}
    />
  );
};
